module.exports = __webpack_public_path__ + "media/images/bg-A-opaque-0eb4c22fa042ae6c65b2a96ac104c167.svg";